<template>
  <div
    class="modal fade"
    id="update-anti-piracy-number"
    tabindex="-1"
    role="dialog"
    aria-labelledby="update-anti-piracy-number-label"
    aria-hidden="true"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div
      class="modal-dialog modal-lg"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header row mx-0 py-1">
          <div class="col col-sm-8">
            <h6
              class="modal-title font-weight-bolder"
              id="update-anti-piracy-number-label"
            >
              Update Anti-Piracy Certificate Number
            </h6>
          </div>
          <div class="col col-sm-4">
            <button
              type="button"
              data-dismiss="modal"
              class="btn btn-sm btn-outline-secondary font-weight-bolder ml-2 float-right"
            >
              Close
            </button>
          </div>
        </div>

        <div class="modal-body p-0">
          <form @submit.prevent="confirmUpdateAntiPiracyCertificateNumber">
            <div class="form-group form-row mt-2">
              <label
                class="col col-sm-3 col-form-label font-weight-bolder text-right pl-0"
                for="certificate-number"
              >Certificate Number:</label>
              <div class="col col-sm-5">
                <input
                  type="text"
                  id="certificate-number"
                  v-model="antiPiracy.certificateNumber"
                  class="form-control form-control-xs form-control-xxs"
                >
              </div>
              <div class="col col-sm-3">
                <button
                  type="submit"
                  class="btn btn-sm btn-xs btn-warning font-weight-bolder my-auto"
                >
                  <span class="fas fa-edit" />
                  Update
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapActions } from 'vuex';
import { formMixins } from "@/mixins/formMixins";

export default {
  name: "UpdateAntiPiracyNumber",

  mixins: [ formMixins ],

  props: {
    antiPiracy: {
      type: Object,
      default() {
        return {};
      }
    },
  },

  methods: {
    ...mapActions([ 'updateAntiPiracyNumber' ]),

    async confirmUpdateAntiPiracyCertificateNumber() {
      if(await this.confirmUpdateAlert('Are you sure you want to update certificate number?')) {
        let params = {
          crewTrainingId: this.antiPiracy.crewTrainingId,
          certificateNumber: this.antiPiracy.certificateNumber
        };
        let updatedCertificateNumber = await this.updateAntiPiracyNumber(params);
        if(updatedCertificateNumber) {
          this.successAlert('Certificate Number Successfully Updated', 'UPDATE');
        } else {
          this.errorAlert('Failed to Update Certificate Number', 'UPDATE RECORD')
        }
      }
    }

  }
}
</script>

<style scoped>

</style>